<template>
  <div
    id="createCommentModal"
    aria-labelledby="createCommentModalLabel"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            ref="close"
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
            @click="onResetForm"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            id="createCommentModalLabel"
            class="modal-title"
          >
            {{ $t('string.addNewComment') }}
          </h4>
        </div>
        <div class="modal-body">
          <div>
            <x-textarea
              v-model="comment"
              :label="$t('string.comment')"
              :placeholder="$t('placeholder.comment')"
              :required="true"
              :rows="5"
              :validations="validations"
              name="comment"
            />

            <div
              :class="{'has-error' : validations['files']}"
              class="form-group"
            >
              <label for="files">
                <input
                  id="files"
                  ref="files"
                  accept="image/png,image/jpeg,image/jpg,.doc,.docx,.pdf"
                  multiple
                  type="file"
                >
                <template v-if="validations['files']">
                  <span class="help-block">{{ validations['files'][0] }}</span>
                </template>
              </label>
            </div>
          </div>
          <div class="form-group">
            <button
              :disabled="isSaveWaiting"
              class="btn btn-primary btn-sm margin-right-5"
              type="button"
              @click="onSave"
            >
              <i
                v-if="isSaveWaiting"
                class="fa fa-spinner fa-spin"
              /> {{ $t('button.submit') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateCommentModal',
  props: {
    borrowId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      validations: {},
      comment: '',
      isSaveWaiting: false
    }
  },
  methods: {
    onResetForm () {
      this.comment = ''
      this.validations = {}
      this.$refs.close.click()
      this.$refs.files.value = null
    },
    onSave () {
      const params = new FormData()
      if (this.comment) {
        params.set('comment', this.comment)
      }
      if (this.borrowId) {
        params.set('borrow_id', this.borrowId)
      }
      if (this.$refs.files.files) {
        const files = this.$refs.files.files
        Object.keys(files).forEach((key) => {
          params.set(`files[${key}]`, files[key])
        })
      }
      this.validations = {}
      this.isSaveWaiting = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/comment/create', params)
        .then(({ data }) => {
          if (data.data) {
            this.comment = ''
            this.$store.commit('comment/setRefreshCommentList')
            this.onResponseSuccess()
            this.onResetForm()
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 15px;
}
</style>
